export default {
    methods: {
        //  Block/Unblock a contact
        toggleBlock(person) {
            //  Grab our current role
            const role = this.$store.getters.userRole(this.$store.getters.user)

            //  Check if this role is an operator
            const operator = window.getProps(role, ['name']) === 'Operator'

            //  If they are an operator let them know they cannot block/unblock contacts and return
            if (operator) {
                this.$store.dispatch('dialogOpen', {
                    type: 'MESSAGE',
                    title: 'Error',
                    message: 'Operators cannot block/unblock contacts'
                })
                return
            }

            //  Get the persons name
            const name = this.$options.filters.personFullNameOrEmail(person)

            //  Check if the person is blocked
            const isBlocked = this.$store.getters.isPersonBlocked(person)

            // Prepare text
            const text = isBlocked ? 'un' : ''

            //  Get confirmation from the user
            this.$store.dispatch('dialogOpen', {
                type: 'CONFIRM',
                title: 'Block Contact?',
                icon: 'mdi-account-cancel',
                text: `Are you sure you want to ${text}block <b>${name}</b>?`,
                callback: async (result) => {
                    // If the user answered 'NO', do nothing
                    if (!result) return
                    
                    const method = isBlocked ? 'phoneNumbersUnblock' : 'phoneNumbersBlock'

                    // Block/unblock the person
                    const response = await this.$store.dispatch(method, [
                        { msisdn: person.phone_default.msisdn }
                    ])

                    // If the request failed, do nothing
                    if (!response) return
                    
                    //  Set temp bool on persons phone number blocked status to change state immediately
                    //  rather than waiting for personsSaved event to finish
                    person.phone_default.blocked = !isBlocked

                    //  Handle removing from 'Blocked Contacts' group
                    if (this.group && this.group.name == 'Blocked Contacts') this.removeFromGroup(person.id)

                    // Prepare text
                    const text = isBlocked ? 'un' : ''
                    const multiple = response.length > 1 ? 's' : ''

                    //  Else, notify the user of success
                    this.$store.commit('appNotificationBarSet', {
                        message: `Contact${multiple} ${text}blocked`
                    })
                }
            })
        },
        blockedContactTooltip(person) {
            const tooltip = this.$store.getters.isPersonBlocked(person)
                ? 'Unblock'
                : 'Block'

            return tooltip
        },
        removeFromGroup(person_id) {
            this.$refs.groupPersonsList && this.$refs.groupPersonsList.removeIds([person_id])
        }
    }
}
